import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form } from 'react-bootstrap';
import { URL_IMG } from '../../../configs/urlConfigs';
import { IMG_CREW_PROFILE } from '../../../configs/imgConfigs';
import { MSG_REQUIRED, MSG_NOT_LOGGED_IN } from '../../../configs/msgConfigs';
import { CREW_MAX_RATING, PHONE_ISD_CODE, PHONE_ISD_NUM } from '../../../configs/staticConfigs';
import { LBL_PREFER_NOT_TO_SAY, LBL_NOT_WILLING_TO_SHARE, LBL_SEL_PAY_LEVEL, LBL_OMNU_POINTS, LBL_PP, LBL_INDUCTION_COMPLETED, LBL_APPROVED, LBL_APPROVE, LBL_AVAILABILITY, LBL_LAST_LOGIN, LBL_FIRST_NAME, LBL_LAST_NAME, LBL_PREFERED_NAME, LBL_MOBILE_NUMBER, LBL_EMAIL_ADDRESS, LBL_ALTERNATE_NUMBER, LBL_GENDER, LBL_SELECT, LBL_MALE, LBL_FEMALE, LBL_THIRD_GENDER, LBL_DOB, LBL_SELECT_A_DATE, LBL_NATIONALITY, LBL_TIME_ZONE, LBL_SELECT_TIME_ZONE, LBL_GET_LOC_FROM_GOOGLE, LBL_STREET_1, LBL_STREET_2, LBL_CITY, LBL_STATE, LBL_COUNTRY, LBL_POST_CODE, LBL_NOTES, LBL_BASIC_INFO, LBL_SAVE, LBL_RESEND_VERIFI_EMAIL, LBL_INDUCT, LBL_CHIEF, LBL_PAY_LEVEL, LBL_DRIVE_TO_SHIFT_LOCATIONS } from '../../../configs/labelConfigs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';

import ModalWindow from '../../commons/helpers/modalWindow';
import CustomMultiSelect from '../../commons/helpers/customMultiSelect';


//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
//import {geocodeByAddress,getLatLng} from 'react-places-autocomplete';
import LocationSearchInput from '../../commons/helpers/googleLocationSearch';
import CountryListComponent from '../../commons/countryListComponent';
import PhoneInput from 'react-phone-input-2';

import { LBL_VENUE_PROFILE, LBL_DEPARTMENTS, LBL_ACTIVATE, LBL_DEACTIVATE, LBL_CONFIRM_ACTIVATE_CREW, LBL_CONFIRM_DEACTIVATE_CREW, LBL_CONFIRM_ACTIVATION, LBL_CONFIRM_DEACTIVATION, LBL_SEND_VERIFI_EMAIL } from '../../../configs/labelConfigs';
import { MSG_LOGO_FORMAT } from '../../../configs/msgConfigs';
import { DISABLE_LOC_DET_EDIT } from '../../../configs/staticConfigs';
import { checkPermissions } from '../../../utils/permissions';

class BasicInfo extends Component {

    constructor(props) {
        super();
        this.state = {
            activeDeactiveText: '',
            chkSendVerifyEmail: true,
        }

        this.modalDelete = React.createRef();
        this.modalActivate = React.createRef();
    }

    renderTooltip(name, props) {
        return (
            <Tooltip id={name} style={{
                opacity: 0.4,
            }} {...props} >
                {name}
            </Tooltip>
        );
    }

    onGetGoogleLocClick = (e) => {
        const instance = this._typeahead.getInstance()
        instance.clear();
        this.props.onGetGoogleLoc(e);
    }

    deleteBtnClick = () => {
        this.setState({ activeDeactiveText: LBL_DEACTIVATE }, () => {
            this.modalDelete.current.handleOpenModal();
        })

    }

    activateClick = () => {
        this.setState({ activeDeactiveText: LBL_ACTIVATE }, () => {
            this.modalActivate.current.handleOpenModal();
        });
    }

    onModalFormResetActivate = () => {

    }

    onModalFormResetDeactivate = () => {

    }

    onSelCountry = (e) => {
        this.props.onHandleChange(e);
    }

    componentDidUpdate(prevProps) {
        const { crewActivatedSuccess, crewDeactivatedSuccess } = this.props;
        if (crewActivatedSuccess && Number(crewActivatedSuccess) > 0 && Number(crewActivatedSuccess) > Number(prevProps.crewActivatedSuccess)) {
            this.modalActivate.current.handleModelCloseOnly();
        }
        if (crewDeactivatedSuccess && Number(crewDeactivatedSuccess) > 0 && Number(crewDeactivatedSuccess) > Number(prevProps.crewDeactivatedSuccess)) {
            this.modalDelete.current.handleModelCloseOnly();
        }
    }

    uploadLogoFile() {
        document.getElementById('uploadLogo').click();
    }

    render() {

        const { deptMultiSelList, crewData, formErrors, imgUrl, crewId, ppPoints, omnuPoints, availabilityStatus, lastlogin, logoLabel, isLogoValid, chiefEligibility, timeZonesList, payLevelList, supervisor_name,driveToShiftLocation } = this.props;
        let logoUrl = require('../../../' + URL_IMG + IMG_CREW_PROFILE);
        if (imgUrl) {
            logoUrl = imgUrl;
        }
        let selectedDob = '';

        if (crewData.basicInfo.dob !== '') {
            selectedDob = new Date(crewData.basicInfo.dob);
        }
        let loggedDate = '';
        let loggedTime = '';
        if (lastlogin !== '') {
            loggedDate = format(new Date(lastlogin), 'PP');
            loggedTime = format(new Date(lastlogin), 'p');
        }
        let companyName = '';
        if (this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;

        const chiefIcon = chiefEligibility ? <span><img className='cheifimg-icon' src={require('../../../'+ URL_IMG +'cheif.svg')}></img></span> : '';
        let vehicleInfo = '';
        if (crewData.basicInfo.has_vehicle === true) {
            vehicleInfo = <span className="chief-icon background-black"><img className="car-image" src={require('../../../' + URL_IMG + 'car_filled.svg')} alt="Action" /></span>;
        } else if (crewData.basicInfo.has_vehicle === false) {
            vehicleInfo = <span className="chief-icon background-grey"><img className="car-image" src={require('../../../' + URL_IMG + 'car_not_filled.svg')} alt="Action" /></span>;
        } else {
            vehicleInfo = '';
        }

        // let disableEditAddress = (!DISABLE_LOC_DET_EDIT && crewData.basicInfo.googleLocation && crewData.basicInfo.googleLocation.length > 0) ? false : true;
        
        let disableEditAddress = (!DISABLE_LOC_DET_EDIT && crewData.basicInfo.googleLocation && crewData.basicInfo.googleLocation.length > 0) ? false : false;

        //Disable save
        let saveDisabled = true;
        if (payLevelList.length > 0) {
            saveDisabled = "";
        }

        return (
            <Form onSubmit={e => this.props.saveFormData(e)} encType="multipart/form-data" autoComplete="off">
                <div className="col-md-12">
                    <div className="box margin-top-12" >
                        {/* <div className="tab-head padding-right-30">
                            <h6 className="paddingTop5">&nbsp;</h6>
                            {LBL_BASIC_INFO} {(companyName) && <span>{' - '+companyName}</span>}
                            <button className="btn btn-primary float-right" disabled={saveDisabled}>{LBL_SAVE}</button>
                        </div> */}
                        <div className="box-content-new margin-top-12">
                            <Row >
                                <div className="col-lg-6 col-xl-3 col-12 margin-top-9" >
                                    <div>
                                        <div className="crew-profile">
                                            <div className="row crew-profile-centering">

                                                <div className="col-5 crew-profile-logo ">
                                                    <div className="company-logo">
                                                        <img src={logoUrl} alt={crewData.basicInfo.firstName + ' ' + crewData.basicInfo.lastName} style={{ cursor: 'pointer', borderRadius: '72px' }} onClick={this.uploadLogoFile} />
                                                        <label htmlFor="uploadLogo"><i className="las la-pen"></i></label>
                                                        <input type="file" id="uploadLogo" name="logo" onChange={this.props.onHandleChange} accept=".jpeg, .jpg, .png, .gif" />
                                                    </div>
                                                </div>



                                            </div>

                                            <div className="margin-top-15 crew-profile-logo-name"  >
                                                <h6 className="text-left mb-1">
                                                    {crewId && crewData.basicInfo.firstName && (
                                                        <>
                                                            {chiefIcon}
                                                            {vehicleInfo}
                                                            {driveToShiftLocation&& <i class="fas fa-solid fa-id-card mr-2"></i>}
                                                            <strong className="text-14">{crewData.basicInfo.firstName + ' ' + crewData.basicInfo.lastName}
                                                            </strong>

                                                        </>
                                                    )}
                                                </h6>
                                            </div>

                                            <div className='width-100-percent'>
                                                {crewId && (ppPoints > 0 ) ? (
                                                    <div>
                                                        <div className='width-100-percent'>

                                                            <small>{LBL_OMNU_POINTS}</small>

                                                            {crewId &&
                                                                <div className="padding-left-0 crew pb-1 ml-3 rating-block " >
                                                                    <div className="crew__rating rating-display-only">
                                                                        {CREW_MAX_RATING.map(ratingNum => {
                                                                            if (Number(ratingNum) <= Number(crewData.basicInfo.crewStarRatings)) {
                                                                                return (
                                                                                    <React.Fragment key={'rating' + ratingNum}><input type="checkbox" defaultChecked={true} name="rating" id={"rating" + ratingNum} disabled={true} /><label htmlFor={"rating" + ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                                                )
                                                                            } else {
                                                                                if (parseFloat(ratingNum) - 0.5 === parseFloat(crewData.basicInfo.crewStarRatings)) {
                                                                                    return (
                                                                                        <React.Fragment key={'rating' + ratingNum}><input type="checkbox" defaultChecked={true} name="rating" id={"rating" + ratingNum} disabled={true} /><label htmlFor={"rating" + ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                                                    )
                                                                                } else {
                                                                                    return (
                                                                                        <React.Fragment key={'ratingcrew' + ratingNum}><input type="checkbox" defaultChecked={false} name="rating" id={"ratingcrew" + ratingNum} disabled={true} /><label htmlFor={"ratingcrew" + ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                                                    )
                                                                                }
                                                                            }
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            }

                                                            <div className='mt-2' ><small>{ppPoints}&nbsp;&nbsp;xp</small></div>

                                                        </div>

                                                    </div>

                                                ) : null}
                                            </div>

                                            <p className={isLogoValid ? 'logo-txt text-left mt-2 mb-2' : 'text-red logo-txt text-left mt-2 mb-2'}><small>{logoLabel}</small></p>
                                           
                                        </div>
                                    </div>

                                    <div>&nbsp;</div>


                                    {/* <div style={{width:"75%"}}> */}
                                    <div className="form-group divFloatLeft"><label>{LBL_PAY_LEVEL + ' '}</label>
                                        <div className="divFloatRight  min-width-125">
                                            <div className="form-group select-input">
                                                <select name="payLevel" onChange={this.props.onHandleChange} value={crewData.basicInfo.payLevel || 0} className={formErrors.payLevel.length > 0 ? "input-error pay-level" : 'pay-level '} tabIndex="1" >
                                                    <option key="0" value="0">{LBL_SEL_PAY_LEVEL}</option>
                                                    {payLevelList && Array.isArray(payLevelList) && payLevelList.length > 0 && payLevelList.map((item) => <option key={item.id} value={item.id}>{item.level_name}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>


                                    {crewId && (
                                        <div >
                                            {/* IF INDUCTION DONE, DISABLE EDITING */}
                                            <div className="form-group divFloatLeft">
                                                <div className="divFloatLeft">
                                                    {crewData.basicInfo.isInducted_server && <label className="text-muted"><b>{LBL_INDUCTION_COMPLETED}</b></label>}
                                                    {!crewData.basicInfo.isInducted_server && <label>{LBL_INDUCT}</label>}
                                                </div>
                                                <div className="divFloatRight padding-right-8">
                                                    <div className="form-group">
                                                        {crewData.basicInfo.isInducted_server &&
                                                            <div className="custom-checkbox padding-right-0">
                                                                <input type="checkbox" id="chkInductionCrew" name="chkInductionCrew" disabled checked={true} className="chk-disabled" />
                                                                <label className="checkbox chk-disabled" ></label>
                                                            </div>
                                                        }
                                                        {!crewData.basicInfo.isInducted_server &&
                                                            <div className="divFloatRight padding-right-0">
                                                                <div className="form-group">
                                                                    <div className="custom-checkbox">
                                                                        <input type="checkbox" id="chkInductionCrew" name="chkInductionCrew" onChange={this.props.onInductionCrew} />
                                                                        <label className="checkbox" htmlFor="chkInductionCrew"></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            {/* IF APPROVAL DONE, DISABLE EDITING */}
                                            <div className="form-group divFloatLeft">
                                                <div className="divFloatLeft">
                                                    {crewData.basicInfo.isApproved_server && <label className="text-muted"><b> {LBL_APPROVED}</b></label>}
                                                    {!crewData.basicInfo.isApproved_server && <label>{LBL_APPROVE}</label>}
                                                </div>
                                                <div className="divFloatRight padding-right-8">
                                                    <div className="form-group">
                                                        {crewData.basicInfo.isApproved_server &&
                                                            <div className="custom-checkbox padding-right-0">
                                                                <input type="checkbox" id="chkApproveCrew" name="chkApproveCrew" disabled checked={true} className="chk-disabled" />
                                                                <label className="checkbox chk-disabled" ></label>
                                                            </div>
                                                        }
                                                        {!crewData.basicInfo.isApproved_server && !crewData.basicInfo.isInducted &&
                                                            <div className="custom-checkbox padding-right-0">
                                                                <input type="checkbox" id="chkApproveCrew" name="chkApproveCrew" disabled className="chk-disabled" />
                                                                <label className="checkbox chk-disabled"></label>
                                                            </div>
                                                        }
                                                        {!crewData.basicInfo.isApproved_server && crewData.basicInfo.isInducted &&
                                                            <div className="custom-checkbox padding-right-0">
                                                                <input type="checkbox" id="chkApproveCrew" name="chkApproveCrew" onChange={this.props.onApproveCrew} checked={crewData.basicInfo.isApproved} />
                                                                <label className="checkbox" htmlFor="chkApproveCrew"></label>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group divFloatLeft">
                                                <div className="divFloatLeft">
                                                    <b className="font-14 text-muted align-left">{LBL_AVAILABILITY}</b>
                                                </div>
                                                <div className="divFloatRight padding-right-8">
                                                    <div className="form-group">
                                                        <div className="custom-checkbox padding-right-0">
                                                            <input type="checkbox" id="chkAvailCrew" name="chkAvailCrew" onChange={this.props.onAvailabilityChange} checked={availabilityStatus} />
                                                            <label className="checkbox" htmlFor="chkAvailCrew"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group divFloatLeft">
                                                <div className="divFloatLeft">
                                                    <b className="font-14 text-muted text-left min-width-65">{supervisor_name}?</b>
                                                </div>
                                                <div className="divFloatRight padding-right-8">
                                                    <div className="form-group">
                                                        <div className="custom-checkbox padding-right-0">
                                                            <input type="checkbox" id="chkChiefCrew" name="chkChiefCrew" onChange={this.props.onChiefEligibility} checked={chiefEligibility} />
                                                            <label className="checkbox" htmlFor="chkChiefCrew"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group divFloatLeft">
                                                <div className="divFloatLeft">
                                                    <b className="font-14 text-muted text-left min-width-65">{LBL_DRIVE_TO_SHIFT_LOCATIONS}</b>
                                                </div>
                                                <div className="divFloatRight padding-right-8">
                                                    <div className="form-group">
                                                        <div className="custom-checkbox padding-right-0">
                                                            <input type="checkbox" id="chkDriveToShift" name="chkDriveToShift" onChange={this.props.onDriveToShiftLocationChange} checked={driveToShiftLocation} />
                                                            <label className="checkbox" htmlFor="chkDriveToShift"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="padding-top-50">&nbsp;</div>
                                            <div className="padding-top-50">&nbsp;</div>
                                            <div className='padding-top-5 '>&nbsp;</div>
                              

                                            <div className="text-left w-100 pt-0 pb-0" >

                                                {crewId && (
                                                    <div >
                                                        <p className="text-muted mb-0" ><small>{LBL_LAST_LOGIN} :
                                                            {lastlogin !== null && (
                                                                <React.Fragment>
                                                                    <i className="las la-calendar-alt"></i> {loggedDate} <i className="lar la-clock"></i> {loggedTime}
                                                                </React.Fragment>
                                                            )}
                                                            {lastlogin === null && (
                                                                <React.Fragment> {MSG_NOT_LOGGED_IN}</React.Fragment>
                                                            )}
                                                        </small>
                                                        </p>
                                                    </div>
                                                )}

                                            </div>


                                            {/* {crewData.basicInfo.isInducted_server &&  
                                                    <div className="form-group divFloatLeft padding-bottom-12">
                                                        <div className="divFloatLeft"><label className="text-muted"><b>{LBL_INDUCTION_COMPLETED}</b></label> </div> 
                                                        <div className="divFloatRight padding-right-8">
                                                            <i className="las la-check bold-icon"></i> 
                                                            <div className="form-group">
                                                                <div className="custom-checkbox padding-right-0">
                                                                    <input type="checkbox" id="chkInductionCrew" name="chkInductionCrew" disabled checked={true}  className="chk-disabled"/>
                                                                    <label className="checkbox chk-disabled" ></label>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                    </div> 
                                                }    */}

                                            {/* {crewData.basicInfo.isInducted_server===false && crewData.basicInfo.isInducted===false &&  
                                                    <div className="form-group divFloatLeft padding-bottom-12">
                                                        <div className="divFloatLeft"><label>{LBL_INDUCT}</label></div> 
                                                        <div className="divFloatRight padding-right-8">
                                                            <div className="form-group">
                                                                <div className="custom-checkbox">
                                                                    <input type="checkbox" id="chkInductionCrew" name="chkInductionCrew"  onChange={this.props.onInductionCrew} />
                                                                    <label className="checkbox" htmlFor="chkInductionCrew"></label>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                    </div> 
                                                }  */}


                                            {/* {crewData.basicInfo.isApproved && 
                                                    <div className="form-group divFloatLeft padding-bottom-12">
                                                        <div className="divFloatLeft"><label className="text-muted"><b> {LBL_APPROVED}</b></label> </div> 
                                                        <div className="divFloatRight padding-right-8">
                                                            <i className="las la-check bold-icon"></i> 
                                                            <div className="form-group">
                                                                <div className="custom-checkbox padding-right-0">
                                                                    <input type="checkbox" id="chkApproveCrew" name="chkApproveCrew" disabled checked={true}  className="chk-disabled"/>
                                                                    <label className="checkbox chk-disabled" ></label>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                    </div> 
                                                }  */}

                                            {/* {crewData.basicInfo.isApproved===false && crewData.basicInfo.isInducted===true &&  
                                                    <div className="form-group divFloatLeft padding-bottom-12">
                                                        <div className="divFloatLeft"><label>{LBL_APPROVE}</label></div>
                                                        <div className="divFloatRight padding-right-8">
                                                            <div className="form-group">
                                                                <div className="custom-checkbox">
                                                                    <input type="checkbox" id="chkApproveCrew" name="chkApproveCrew"  onChange={this.props.onApproveCrew} />
                                                                    <label className="checkbox" htmlFor="chkApproveCrew"></label>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                    </div> 
                                                }    */}

                                            {/* {crewId && crewData.basicInfo.isApproved===false && crewData.basicInfo.isInducted===false &&   
                                                    <div className="form-group divFloatLeft padding-bottom-12">
                                                        <div className="divFloatLeft"><label>{LBL_APPROVE}</label></div> 
                                                        <div className="divFloatRight padding-right-8">
                                                            <div className="form-group">
                                                                <div className="custom-checkbox padding-right-0">
                                                                    <input type="checkbox" id="chkApproveCrew" name="chkApproveCrew" disabled  className="chk-disabled"/>
                                                                    <label className="checkbox chk-disabled" ></label>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                    </div> 
                                                }
                                                 */}

                                            {/* <div className="form-group divFloatLeft">
                                                        <div className="divFloatLeft"><b className="font-14 text-muted align-left">{LBL_AVAILABILITY}</b> </div> 
                                                        <div className="divFloatRight"><div className="custom-switch align-right">
                                                            <input type="checkbox" 
                                                            checked={availabilityStatus}
                                                            className="custom-control-input align-right" name="availabilityStatus" id="switch1" onChange={this.props.onAvailabilityChange}
                                                            />
                                                            <label className="custom-control-label align-right" htmlFor="switch1"></label>
                                                        </div></div>
                                                </div> */}

                                            {/* <div className="form-group divFloatLeft">
                                                        <div className="divFloatLeft"><b className="font-14 text-muted text-left min-width-65">{supervisor_name}?</b> </div> 
                                                        <div className="divFloatRight padding-right-0"><div className="custom-switch align-right padding-right-0">
                                                            <input type="checkbox" 
                                                            checked={chiefEligibility}
                                                            className="custom-control-input padding-right-0" name="chiefEligibility" id="check2" onChange={this.props.onChiefEligibility}
                                                            />
                                                            <label className="custom-control-label padding-right-0" htmlFor="check2"></label>
                                                        </div></div>
                                                </div> */}
                                        </div>
                                    )}

                                    {/* </div>     */}

                                </div>

                                <div className="col-lg-6 col-xl-9 col-12 pl-2">
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>{LBL_FIRST_NAME}</label>
                                                <div className="text-input"><input type="text" className={formErrors.firstName.length > 0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="firstName" value={crewData.basicInfo.firstName || ''} tabIndex="2" maxLength={29} />
                                                </div>
                                                {formErrors.firstName.length > 0 && formErrors.firstName !== MSG_REQUIRED && (
                                                    <div className="text-red left-align text-12">{formErrors.firstName}</div>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>{LBL_LAST_NAME}</label>
                                                <div className="text-input"><input type="text" className={formErrors.lastName.length > 0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="lastName" value={crewData.basicInfo.lastName || ''} tabIndex="3" maxLength={120} />
                                                </div>
                                            </div>
                                        </Col> 
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label>{LBL_PREFERED_NAME}</label>
                                                <div className="text-input"><input type="text" className={formErrors.preferedName && formErrors.preferedName.length >0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="preferedName" value={crewData.basicInfo.preferedName || ''}  tabIndex="3"  maxLength={120} />
                                                </div>
                                            </div>
                                        </Col>

                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_EMAIL_ADDRESS}</label>
                                                <div className="input email-input">
                                                    <input type="email" className={formErrors.emailAddress.length > 0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="emailAddress" value={crewData.basicInfo.emailAddress || ''} tabIndex="4" maxLength={120} /></div>
                                                {formErrors.emailAddress.length > 0 && formErrors.emailAddress !== MSG_REQUIRED && (
                                                    <div className="text-red left-align text-12">{formErrors.emailAddress}</div>
                                                )}
                                                <small className="text-red">{this.props.crewId && crewData.basicInfo.emailVerify === false && crewData.basicInfo.emailAddress ? 'Not Verified ' : ''}</small>
                                                <Link className={this.props.crewId && crewData.basicInfo.emailVerify === false && crewData.basicInfo.emailAddress ? 'resend-btn float-right' : 'hide'} to="#" onClick={e => this.props.resendEmail(crewData.basicInfo.userId)}>{LBL_RESEND_VERIFI_EMAIL}</Link>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_MOBILE_NUMBER}</label>
                                                <div className={formErrors.contactNumber.length > 0 ? 'input-error' : ''}>
                                                    <PhoneInput
                                                        country={PHONE_ISD_CODE}
                                                        inputProps={{
                                                            name: 'contactNumber',
                                                            tabIndex: "5"
                                                        }}
                                                        value={crewData.basicInfo.contactNumber || PHONE_ISD_NUM}
                                                        onChange={this.props.onPhoneInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_ALTERNATE_NUMBER}</label>
                                                <PhoneInput
                                                    country={PHONE_ISD_CODE}
                                                    inputProps={{
                                                        name: 'alternateContactNum',
                                                        tabIndex: "6"
                                                    }}
                                                    value={crewData.basicInfo.alternateContactNum || PHONE_ISD_NUM}
                                                    onChange={this.props.onAlternatePhoneInputChange}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_GENDER}</label>
                                                <div className="form-group select-input">
                                                    <select onChange={this.props.onHandleChange} name="gender" className={formErrors.gender.length > 0 ? "input-error" : ''} value={crewData.basicInfo.gender || ''} tabIndex="7" >
                                                        <option value="0">{LBL_SELECT}</option>
                                                        <option value="Male">{LBL_MALE}</option>
                                                        <option value="Female">{LBL_FEMALE}</option>
                                                        <option value="Third Gender">{LBL_THIRD_GENDER}</option>
                                                        <option value="Prefer not to say">{LBL_PREFER_NOT_TO_SAY}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_DOB}</label>
                                                <div className="input-input">
                                                    <DatePicker selected={selectedDob}
                                                        name="dob"
                                                        onChange={selected => this.props.onDateChange(selected)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText={LBL_SELECT_A_DATE}
                                                        maxDate={new Date()}
                                                        minDate={new Date('1940/01/01')}
                                                        fixedHeight
                                                        tabIndex="8"
                                                        popperProps={{
                                                            positionFixed: true // use this to make the popper position: fixed
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_NATIONALITY}</label>
                                                <div className="form-group select-input">
                                                    <CountryListComponent countryFieldName={this.props.countryFieldName} countryListClass={formErrors.nationality.length > 0 ? "input-error" : ''} countrySelected={crewData.basicInfo.nationality} onSelCountry={countryId => this.onSelCountry(countryId)} arrCountryList={this.props.arrCountryList} inputProps={{ tabIndex: "9" }} tabIndex="9" ></CountryListComponent>
                                                </div>
                                                {/* <div className="input-input"><input type="text" onChange={this.props.onHandleChange} name="nationality" value={crewData.basicInfo.nationality || ''}/></div> */}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_DEPARTMENTS}</label>
                                                <div className="form-group multisel_textbox">
                                                    <div className="form-group select-input skills" >
                                                        <CustomMultiSelect id={'dept'} data={deptMultiSelList} trimString='yes' onChange={selected => this.props.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex: "10" }} tabIndex="10" classValue={formErrors.department.length > 0 ? "input-error" : ''} needSelectAll="yes" />
                                                    </div>
                                                </div>
                                            </div>

                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_TIME_ZONE}</label>
                                                <div className={crewId ? 'form-group select-input text-optional' : 'form-group select-input'}>
                                                    <select name="timeZone" onChange={this.props.onHandleChange} value={crewData.basicInfo.timeZone ? crewData.basicInfo.timeZone : (this.props.defaultTimeZoneId ? this.props.defaultTimeZoneId : "")} className={formErrors.timeZone.length > 0 ? "input-error" : ''} disabled={crewId} tabIndex="11">
                                                        <option value=''>{LBL_SELECT_TIME_ZONE}</option>
                                                        {timeZonesList.map((item) => <option key={item.id} value={item.id}>{item.region}</option>)}
                                                        {/* UTC'+item.offset */}
                                                    </select>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <h6 className='detail-head border-bottom ' style={{ marginLeft: "15px" }}><b>Address</b></h6>


                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_GET_LOC_FROM_GOOGLE}<sup>
                                                    <button type="button" className="tootltip-btn"
                                                        data-toggle="tooltip" data-placement="top" title=""
                                                        data-original-title="Type address to get the location from google map">
                                                        <i className="las la-question-circle"></i>
                                                    </button></sup> </label>
                                                <div className="text-input">
                                                    {/* <input type="text" placeholder=" " name="googleLocation" onChange={this.props.onHandleChange}/> */}
                                                    <LocationSearchInput name="googleLocation" googleLocSelect={this.props.googleLocSelect} disabled={this.props.disableLocationSearch} className={formErrors.locationName && formErrors.locationName.length > 0 ? " input-error" : ''} resetGoogleLocation={this.props.resetGoogleLocation} />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_VENUE_PROFILE}</label>
                                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}>
                                                    <input type="text" placeholder={LBL_VENUE_PROFILE} name="venue" onChange={this.props.onHandleChange} value={crewData.basicInfo.venue || ''} maxLength={125} />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_STREET_1}</label>
                                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" name="streetOne" onChange={this.props.onHandleChange} className={formErrors.streetOne.length > 0 ? "input-error" : ''} value={crewData.basicInfo.streetOne || ''} disabled={disableEditAddress} maxLength={120} /></div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_STREET_2}</label>
                                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" name="streetTwo" onChange={this.props.onHandleChange} className={formErrors.streetTwo.length > 0 ? "input-error" : ''} value={crewData.basicInfo.streetTwo || ''} disabled={disableEditAddress} maxLength={120} /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_CITY}</label>
                                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" name="city" onChange={this.props.onHandleChange} className={formErrors.city.length > 0 ? "input-error" : ''} value={crewData.basicInfo.city || ''} disabled={disableEditAddress} maxLength={120} /></div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_STATE}</label>
                                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" name="state" onChange={this.props.onHandleChange} className={formErrors.state.length > 0 ? "input-error" : ''} value={crewData.basicInfo.state || ''} disabled={disableEditAddress} maxLength={120} /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_COUNTRY}</label>
                                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" name="country" onChange={this.props.onHandleChange} className={formErrors.country.length > 0 ? "input-error" : ''} value={crewData.basicInfo.country || ''} disabled={disableEditAddress} maxLength={120} />
                                                </div>

                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>{LBL_POST_CODE}</label>
                                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" name="postcode" onChange={this.props.onHandleChange} className={formErrors.postcode.length > 0 ? "input-error" : ''} value={crewData.basicInfo.postcode || ''} disabled={disableEditAddress} maxLength={60} /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>{LBL_NOTES}</label>
                                                <div className="input-input"><textarea name="additionalText" onChange={this.props.onHandleChange} value={crewData.basicInfo.additionalText || ''}
                                                    className="form-control"></textarea></div>
                                            </div>
                                        </div>
                                    </Row>

                                    <div className="clearfix padding-right-15">
                                        {/* <button className="btn btn-primary float-right" disabled={saveDisabled}>{LBL_SAVE}</button>  */}
                                        {crewId && <div className="form-group">
                                            <button className="btn btn-primary float-right" disabled={saveDisabled}>{LBL_SAVE}</button>
                                        </div>}

                                        {!crewId && <div className="form-group">
                                            <button className="btn btn-primary float-right" disabled={saveDisabled}>{LBL_SAVE}</button>
                                            <div className="custom-checkbox">
                                                <input type="checkbox" id="chkSendVerifyEmail" name="chkSendVerifyEmail" onChange={this.props.onHandleChange} checked={crewData.basicInfo.chkSendVerifyEmail} value={crewData.basicInfo.chkSendVerifyEmail} />
                                                <label className="checkbox" htmlFor="chkSendVerifyEmail"></label>
                                                <label className="labeltext" htmlFor="chkSendVerifyEmail">{LBL_SEND_VERIFI_EMAIL}</label>
                                            </div>
                                        </div>}

                                        <div className="padding-left-15">
                                            {(crewId && crewData.basicInfo.affiliate_relation_status) ? (
                                                <Link onClick={this.deleteBtnClick} className="text-danger mt-1 float-left" to="#"><u>{LBL_DEACTIVATE}</u></Link>
                                            ) : ''}
                                            {(crewId && !crewData.basicInfo.affiliate_relation_status) ? (
                                                <Link onClick={this.activateClick} className="text-danger mt-1 float-left" to="#"><u>{LBL_ACTIVATE}</u></Link>
                                            ) : ''}
                                        </div>
                                    </div>
                                </div>

                                <div className="padding-top-50">&nbsp;</div>
                                <div className="padding-top-50">&nbsp;</div>
                                <div className="padding-top-50">&nbsp;</div>
                                <div className="padding-top-50">&nbsp;</div>
                                <div className="padding-top-50">&nbsp;</div>
                                <div className="padding-top-50">&nbsp;</div>
                                <div className="padding-top-50">&nbsp;</div>
                            </Row>
                            <div className="padding-top-50">&nbsp;</div>
                            <div className="padding-top-50">&nbsp;</div>
                            <div className="padding-top-50">&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DEACTIVATION} type="confirm" deleteConfirmedItem={this.props.deleteCrew} resetModalForm={this.onModalFormResetDeactivate}>
                    {LBL_CONFIRM_DEACTIVATE_CREW + " '" + crewData.basicInfo.firstName + ' ' + crewData.basicInfo.lastName + "'?"}
                </ModalWindow>

                <ModalWindow ref={this.modalActivate} header={LBL_CONFIRM_ACTIVATION} type="confirm" deleteConfirmedItem={this.props.activateCrew} resetModalForm={this.onModalFormResetActivate}>
                    {LBL_CONFIRM_ACTIVATE_CREW + " '" + crewData.basicInfo.firstName + ' ' + crewData.basicInfo.lastName + "'?"}
                </ModalWindow>
            </Form>
        )
    }
}

export default BasicInfo;